import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SERVICES } from "../../lib/data";
import { ArrowUpRight } from "lucide-react";

export default function Services({ onOpenLead }) {
  return (
    <section
      data-testid="services-section"
      className="relative py-28 md:py-40 px-6 md:px-10 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="eyebrow mb-4">Our Services</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
              A single,{" "}
              <span className="gold-gradient-text italic">trusted</span>{" "}
              partner — for every step.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-white/60 text-lg font-light leading-relaxed">
              From the first conversation to the final registration, our team
              orchestrates every detail so you can invest with absolute
              confidence.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <motion.button
                key={s.title}
                data-testid={`service-card-${i}`}
                onClick={onOpenLead}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="group relative text-left glass p-8 md:p-10 hover:border-[#D4AF37]/40 hover:-translate-y-1 transition-all duration-500"
              >
                <div className="flex items-start justify-between">
                  <Icon
                    className="w-8 h-8 text-[#D4AF37]"
                    strokeWidth={1.2}
                  />
                  <ArrowUpRight
                    className="w-5 h-5 text-white/30 group-hover:text-[#D4AF37] group-hover:rotate-45 transition-all duration-500"
                    strokeWidth={1.2}
                  />
                </div>
                <h3 className="mt-8 font-serif text-2xl md:text-3xl text-white font-light">
                  {s.title}
                </h3>
                <p className="mt-3 text-white/60 text-sm leading-relaxed font-light">
                  {s.desc}
                </p>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
